function sendError(error, tagName) {
    if (typeof rg4js === 'function') {
        rg4js('send', {
          error: error,
          tags: [tagName]
        });
      }
}

module.exports = {
    sendError : sendError
}